import PropTypes from "prop-types";
// material
import { alpha, styled } from "@mui/material/styles";
import {
  Alert,
  AlertTitle,
  Box,
  Link,
  Stack,
  Dialog, DialogActions, DialogContent, DialogTitle,
  AppBar,
  Toolbar,
  IconButton,
  Button,
  Badge,
  Typography,
} from "@mui/material";
import { LoadingButton } from "@mui/lab";
// components
import Iconify from "../../components/Iconify";
import { MuiDialog } from "src/components";
import Searchbar from "./Searchbar";
import AccountPopover from "./AccountPopover";
import NotificationsPopover from "./NotificationsPopover";
import { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { useAppContext } from "src/hooks";
import { get_from_localStorage } from "src/utils";
import ActiveTimer from "./ActiveTimer";
import CustomDialog from "src/pages/Notes/CustomDialog";
import { useSnackbar } from "notistack";
import ChatNotificationDialog from "src/pages/Chats/components/ChatNotificationDialog";

// ----------------------------------------------------------------------

const DRAWER_WIDTH = 280;
const APPBAR_DESKTOP = "8vh";
const APPBAR_MOBILE = "8vh";

const RootStyle = styled(AppBar)(({ theme }) => ({
  boxShadow: "none",
  backdropFilter: "blur(6px)",
  WebkitBackdropFilter: "blur(6px)", // Fix on Mobile
  backgroundColor: "#f7f9f8",
  // backgroundColor: alpha(theme.palette.background.default, 0.72),
  [theme.breakpoints.up("lg")]: {
    width: `calc(100% - ${DRAWER_WIDTH + 1}px)`,
  },
}));

const ToolbarStyle = styled(Toolbar)(({ theme }) => ({
  minHeight: APPBAR_MOBILE,
  [theme.breakpoints.up("lg")]: {
    // minHeight: APPBAR_DESKTOP,
    // padding: theme.spacing(0, 5),
  },
  // padding for smaller screens - shamroz
  [theme.breakpoints.down("sm")]: {
    paddingLeft: theme.spacing(0.75),
    paddingRight: theme.spacing(0.75),
  },
}));

// ----------------------------------------------------------------------

DashboardNavbar.propTypes = {
  onOpenSidebar: PropTypes.func,
};

export default function DashboardNavbar({ onOpenSidebar }) {
  const { enqueueSnackbar } = useSnackbar();
  const [isOpened, setIsOpened] = useState(false);
  const [loading, setLoading] = useState(true);
  const [updateItem, setUpdateItem] = useState();
  const [page, setPage] = useState(1);
  const [feature, setFeature] = useState(0);
  const [anchorEl, setAnchorEl] = useState(null);
  const navigate = useNavigate();
  const {
    dispatch_get_search_visibility,
    dispatch_set_search_visibility,
    dispatch_get_user_profile,
    badge,
    setIsOpenChatDialog,
    setIsOpenChatNotificationDialog,
    setChatType,
    pageTitle,
  } = useAppContext();
  console.log(badge, "badge");
  let visible = dispatch_get_search_visibility();

  const onPlansClick = () => {
    window.open(
      `${window.location.origin}/plansLink?token=${get_from_localStorage(
        "token"
      )}`
    );
  };

  // ---------------------------------------------------------
  return (
    <RootStyle id="mui-root-style">
      <ToolbarStyle>
        <IconButton
          onClick={onOpenSidebar}
          sx={{ p: 0.5, mr: 0.5, color: "text.primary", display: { lg: "none" } }}
        >
          <Iconify icon="eva:menu-2-fill" />
        </IconButton>

        {pageTitle?.title && pageTitle?.show === true && (
          <Typography
            sx={{
              color: "text.primary",
              fontSize: { xs: "12px", md: "16px" },
              display: { xs: "none", md: "block" },
              fontWeight: 500
            }}>
            {pageTitle?.title}
          </Typography>
        )}
        {/* {visible && <Searchbar />} */}
        {visible ? (
          <Searchbar />
        ) : (
          <Box sx={{ display: { xs: "none", sm: "none", md: "block" }, width: "36px", height: "36px" }} />
        )}

        <Box sx={{ flexGrow: 1 }} />
        <ActiveTimer />
        <Box sx={{ flexGrow: 1 }} />

        <Stack
          direction="row"
          alignItems="center"
          spacing={{ xs: 0.5, sm: 1.5 }}
        >


          {/* <Button onClick={onPlansClick} variant="outlined">
            <Typography fontWeight={"bold"}>Upgrade</Typography>
            <Iconify
              icon="tabler:premium-rights"
              sx={{ height: "24px", width: "24px", color: "#dbb90f" }}
            />
          </Button> */}
          {/* <Button
            // variant="outlined"
            sx={{ bgcolor: "#fff" }}
            onClick={() => { setIsOpened(true) }}
          >
            <Iconify
              icon="mdi:update"
              sx={{ width: "24px", height: "24px", mr: 1 }}
            />

            Recent Updates
          </Button> */}
          {/* <IconButton
            sx={{ bgcolor: "#fff" }}
            onClick={() => navigate("/chats")}
          >
            <Badge
              badgeContent={badge?.chat}
              color="error"
              invisible={!(badge?.chat > 0)}
            >
              <Iconify
              icon="mdi:update"
              sx={{ width: "24px", height: "24px", color: "rgb(0, 171, 85)" }}
            />
            </Badge>
          </IconButton> */}
          <IconButton
            sx={{ bgcolor: "#fff" }}
            onClick={(e) => {
              // setIsOpenChatDialog(false);
              // navigate("/chats");
              setChatType("all");
              setIsOpenChatNotificationDialog(true);
              setAnchorEl(e.currentTarget);
            }}
          >
            <Badge
              badgeContent={badge?.chat}
              color="error"
              invisible={!(badge?.chat > 0)}
            >
              <Iconify
                icon="heroicons-outline:chat"
                sx={{ width: "24px", height: "24px", color: "rgb(0, 171, 85)" }}
              />
            </Badge>
          </IconButton>
          <ChatNotificationDialog setAnchorEl={setAnchorEl} anchorEl={anchorEl} />
          <Button
            // variant="outlined"
            sx={{ bgcolor: "#fff" }}
            onClick={() => navigate("/workspaces/create")}
          >
            <Iconify
              icon="basil:add-outline"
              sx={{ width: "24px", height: "24px" }}
            />
            <span className="d-none d-md-block ms-1">
              Create workspace
            </span>
          </Button>
          <NotificationsPopover />
          <AccountPopover />
        </Stack>
      </ToolbarStyle>

    </RootStyle>
  );
}




